import React, { useState } from 'react';
import { Button, Loader } from '@wix/design-system';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './HeroCard.css';
export const HeroCtaButton = _ref => {
  let onClick = _ref.onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$priority = _ref.priority,
    priority = _ref$priority === void 0 ? 'primary' : _ref$priority,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    dataHook = _ref.dataHook;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const _useState = useState(false),
    isClickLoading = _useState[0],
    setIsClickLoading = _useState[1];
  const isPrimary = priority === 'primary';
  const handleClick = async () => {
    if (!onClick) {
      return;
    }
    setIsClickLoading(true);
    try {
      await onClick();
    } finally {
      setIsClickLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Button, {
    size: size,
    priority: priority,
    skin: "dark",
    fullWidth: fullWidth,
    className: [s.HeroGetItButton, isPrimary && s.HeroGetItButtonPrimary, fullWidth && s.stackedCta].filter(Boolean).join(' '),
    disabled: disabled || isClickLoading,
    onClick: handleClick,
    dataHook: dataHook
  }, isClickLoading ? /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }) : t('domain_search_gate.results.hero.cta.make_it_yours'));
};
//# sourceMappingURL=HeroCtaButton.js.map